import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import {
  convertStraight,
  convertTo12HourFormat,
} from "../../../common-data/Converts";
import { fetchHygineFrequenciesTasksData } from "../../../../redux/hygiene-reducers/hygieneSlice";
import FrequenecyTasksMobile from "./FrequenecyTasksMobile";
import ReactImageGallery from "../../../components-react/gallery/ReactImageGallery";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import TaskUpdateForm from "./TaskUpdateForm";
import { TaskVerifyWithDetails } from "../task-verify/TaskVerify";
import DetailListings from "../task-verify/DetailListings";
import CommonTable from "../../../common-components/common-tables/CommonTable";
import {
  CalendarIcon,
  CallIcon,
  CheckCircleIcon,
  ClockIconV3,
  DoubleCheckIcon,
  EyeIcon,
  IdIcon,
  MultiImageIcon,
  PersonIcon,
  UploadIcon,
  VideoIcon,
  XCircleIcon,
} from "../../../../images/icons/icons";

const FrequenecyTasks = ({
  userInfoData,
  selectedTab,
  selectedFrequencyTab,
  isPage,
  setIsPage,
  callFunction,
  prevFilters,
}) => {
  const dispatch = useDispatch();
  const {
    hygineFrequencyTasksLoading,
    hygineFrequencyTasksError,
    hygineFrequencyTasks,
  } = useSelector((state) => state.hygiene);

  const isAdmin = userInfoData?.account_type === "admin";

  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    status: selectedTab || "",
    frequency_type: selectedFrequencyTab || "",
    ...prevFilters,
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  function onCloseModal() {
    setModValues(iniModValues);
  }

  function getHygieneFrequencyTasks(filters) {
    dispatch(
      fetchHygineFrequenciesTasksData({
        filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (filters?.frequency_type) {
      getHygieneFrequencyTasks(filters);
    }
  }, [filters]);

  useEffect(() => {
    if (
      !hygineFrequencyTasksLoading &&
      !hygineFrequencyTasksError &&
      hygineFrequencyTasks?.status &&
      hygineFrequencyTasks?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: hygineFrequencyTasks.data,
        pagination:
          hygineFrequencyTasks?.pagination?.length > 0
            ? hygineFrequencyTasks.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [
    hygineFrequencyTasksLoading,
    hygineFrequencyTasksError,
    hygineFrequencyTasks,
  ]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      status: selectedTab || "",
      frequency_type: selectedFrequencyTab || "",
      ...prevFilters,
    }));
  }, [isPage, pageLimit, selectedTab, selectedFrequencyTab, prevFilters]);

  const tbColumns = [
    (selectedTab === "all" ||
      selectedTab === "pending" ||
      selectedTab === "rejected" ||
      selectedTab === "all_rejected") &&
      !isAdmin && {
        dataField: "status",
        text: "update task",
        formatter: (_, row) => {
          const isDisable =
            row?.status !== "pending" &&
            selectedTab !== "rejected" &&
            selectedTab !== "all_rejected";

          return (
            <div className="pp-employee-payroll-actions">
              <button
                key="pt-trainer"
                type="button"
                disabled={isDisable}
                className={`pp-employee-payroll-action-button pp-outlined-border ${
                  isDisable ? "disabled" : ""
                }`}
                onClick={() =>
                  !isDisable &&
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "update",
                    rowData: row,
                  }))
                }
              >
                <UploadIcon color={isDisable ? "gray" : "#000"} />
                update
              </button>
            </div>
          );
        },
      },
    (selectedTab === "all" ||
      selectedTab === "completed" ||
      selectedTab === "re_submitted") &&
      isAdmin && {
        dataField: "status",
        text: "verify submitted task",
        formatter: (_, row) => {
          const isEnabled =
            (row?.status === "completed" || selectedTab === "re_submitted") &&
            row?.approval_status === 0;

          return (
            <div className="pp-employee-payroll-actions">
              <button
                key="pt-trainer"
                type="button"
                disabled={!isEnabled}
                className={`pp-employee-payroll-action-button pp-outlined-border ${
                  !isEnabled ? "disabled" : ""
                }`}
                style={{
                  color:
                    row?.approval_status === 1
                      ? "green"
                      : row?.approval_status === 2
                      ? "red"
                      : "#000",
                  borderColor:
                    row?.approval_status === 1
                      ? "green"
                      : row?.approval_status === 2
                      ? "red"
                      : "#000",
                }}
                onClick={() =>
                  isEnabled &&
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "verify",
                    rowData: row,
                  }))
                }
              >
                {row?.approval_status === 1 ? (
                  <DoubleCheckIcon color="green" />
                ) : row?.approval_status === 2 ? (
                  <XCircleIcon />
                ) : (
                  <DoubleCheckIcon />
                )}
                {row?.approval_status === 1
                  ? "approved"
                  : row?.approval_status === 2
                  ? "rejected"
                  : "verify task"}
              </button>
            </div>
          );
        },
      },
    {
      dataField: "task_id",
      text: "task name",
      formatter: (_, row) => {
        const taskName = row?.task_name || "NA";
        const isLong = taskName.length > 50;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {row?.task_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "category",
      text: "category",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.category_name || "NA"}</span>;
      },
    },
    selectedTab === "all" && {
      dataField: "status",
      text: "task status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-badge ${
              row?.status === "completed"
                ? "tb-badge-success"
                : row?.status === "missed"
                ? "not-assigned"
                : "tb-badge-success-1"
            }`}
          >
            {row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    (selectedTab === "all" ||
      selectedTab === "completed" ||
      selectedTab === "approved" ||
      selectedTab === "rejected" ||
      selectedTab === "all_rejected" ||
      selectedTab === "re_submitted") && {
      dataField: "task_status_id",
      text: "task info",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.task_status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "start_time",
      text: "start & end time",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <ClockIconV3 color="#2c3e50" />
              </span>{" "}
              <span className="tb-data">
                {row?.start_time ? convertTo12HourFormat(row.start_time) : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <ClockIconV3 color="#2c3e50" />
              </span>{" "}
              <span className="tb-data">
                {row?.end_time ? convertTo12HourFormat(row.end_time) : "-"}
              </span>
            </div>
          </div>
        );
      },
    },
    selectedTab !== "approved" &&
      selectedTab !== "rejected" &&
      selectedTab !== "all_rejected" && {
        dataField: "media_required",
        text: "media required",
        formatter: (_, row) => {
          const imgArrayLength =
            Number(row?.images_arr?.length || 0) > 0 &&
            Number(row?.img_quantity || 0) > 0;
          const vdoArrayLength =
            Number(row?.video_arr?.length || 0) > 0 &&
            Number(row?.vid_quantity || 0) > 0;

          return (
            <div className="tb-flex">
              {row?.media_required ? (
                <div className="tb-flex-col">
                  <div className="tb-flex">
                    <span
                      className="tb-data tb-info-icon"
                      onClick={() =>
                        imgArrayLength &&
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          cardName: "images",
                          rowData: row,
                        }))
                      }
                    >
                      <MultiImageIcon color={imgArrayLength ? "#3396d3" : ""} />
                    </span>
                    <span
                      className={`tb-data ${imgArrayLength ? "tb-link" : ""}`}
                      onClick={() =>
                        imgArrayLength &&
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          cardName: "images",
                          rowData: row,
                        }))
                      }
                    >
                      {row?.img_quantity || 0}
                    </span>
                  </div>

                  <div className="tb-flex">
                    <span
                      className="tb-data tb-info-icon"
                      onClick={() =>
                        vdoArrayLength &&
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          cardName: "videos",
                          rowData: row,
                        }))
                      }
                    >
                      <VideoIcon color={vdoArrayLength ? "#3396d3" : ""} />
                    </span>
                    <span
                      className={`tb-data ${vdoArrayLength ? "tb-link" : ""}`}
                      onClick={() =>
                        vdoArrayLength &&
                        setModValues((prevs) => ({
                          ...prevs,
                          isModOpen: true,
                          cardName: "videos",
                          rowData: row,
                        }))
                      }
                    >
                      {row?.vid_quantity || 0}
                    </span>
                  </div>
                </div>
              ) : (
                <span className="tb-data tb-icon">
                  <XCircleIcon />
                </span>
              )}
            </div>
          );
        },
      },
    (selectedTab === "all" ||
      selectedTab === "completed" ||
      selectedTab === "approved" ||
      selectedTab === "rejected" ||
      selectedTab === "all_rejected" ||
      selectedTab === "re_submitted") && {
      dataField: "submitted_by",
      text: "submitted by",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.submitted_by_name || "NA"}</span>
            </div>

            {row?.submitted_by_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">
                  {row?.submitted_by_mobile || ""}
                </span>
              </div>
            )}

            {row?.submitted_by_account_type && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <IdIcon />
                </span>
                <span className="tb-data">
                  {row.submitted_by_account_type?.replace(/_/g, " ") || ""}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    isAdmin && {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 30;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "priority",
      text: "priority",
      formatter: (_, row) => {
        const taskPriroty = row?.priority || "";
        const priorityColor =
          taskPriroty === "critical"
            ? "#dc3545"
            : taskPriroty === "high"
            ? "#ffc107"
            : taskPriroty === "medium"
            ? "#0d6efd"
            : "#198754";
        const priorityTag =
          taskPriroty === "critical"
            ? "P1"
            : taskPriroty === "high"
            ? "P2"
            : taskPriroty === "medium"
            ? "P3"
            : "P4";

        return (
          <span
            className="tb-data tb-badge"
            style={{
              backgroundColor: priorityColor,
              color: "#fff",
            }}
          >
            ({priorityTag}) {row?.priority || "-"}
          </span>
        );
      },
    },
    {
      dataField: "stakeholders",
      text: "stakeholders",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.stakeholders || "NA"}</span>;
      },
    },
    {
      dataField: "task_date",
      text: "task add date",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <CalendarIcon color="#2c3e50" />
            </span>
            <span className="tb-data">
              {row?.task_date ? convertStraight(row.task_date) : "-"}
            </span>
          </div>
        );
      },
    },
    selectedTab !== "approved" &&
      selectedTab !== "rejected" &&
      selectedTab !== "all_rejected" && {
        dataField: "add_gym_req",
        text: "create ticket",
        formatter: (_, row) => {
          return (
            <div className="tb-flex">
              <span className="tb-data tb-icon">
                {row?.add_gym_req ? <CheckCircleIcon /> : <XCircleIcon />}
              </span>
              {row?.description && (
                <span className="tb-data">
                  <span
                    className="tb-data tb-link"
                    onClick={() =>
                      setModValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        cardName: "description",
                        rowData: row,
                      }))
                    }
                  >
                    read
                  </span>
                </span>
              )}
            </div>
          );
        },
      },
    (selectedTab === "approved" ||
      selectedTab === "rejected" ||
      selectedTab === "all_rejected") && {
      dataField: "details",
      text: "view details",
      formatter: (_, row) => {
        return (
          <div className="pp-employee-payroll-actions">
            <button
              key="pt-trainer"
              type="button"
              className={`pp-employee-payroll-action-button pp-outlined-border`}
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "view_details",
                  rowData: row,
                }));
              }}
            >
              <EyeIcon />
              view details
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer mod-width-50p`}>
          <ModalHeadAndClose
            title={
              modValues.cardName === "update"
                ? modValues.rowData?.task_name
                : modValues.cardName === "verify"
                ? `verify task - ${modValues.rowData?.task_name || ""}`
                : modValues.cardName === "description"
                ? modValues.rowData?.task_name || ""
                : modValues.cardName?.replace(/_/g, " ")
            }
            onClose={onCloseModal}
          />

          {modValues.cardName === "images" ||
          modValues.cardName === "videos" ? (
            <div className="image-gallery-container">
              <ReactImageGallery
                imagesArray={
                  modValues.cardName === "videos"
                    ? modValues.rowData?.video_arr?.length > 0
                      ? modValues.rowData.video_arr
                      : []
                    : modValues.rowData?.images_arr?.length > 0
                    ? modValues.rowData.images_arr
                    : []
                }
              />
            </div>
          ) : modValues.cardName === "update" ? (
            <TaskUpdateForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              callFunction={() => {
                getHygieneFrequencyTasks(filters);
                callFunction();
                onCloseModal();
              }}
            />
          ) : modValues.cardName === "verify" ? (
            <TaskVerifyWithDetails
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              callFunction={() => {
                getHygieneFrequencyTasks(filters);
                callFunction();
                onCloseModal();
              }}
              closeModal={onCloseModal}
            />
          ) : modValues.cardName === "view_details" ? (
            <DetailListings row={modValues.rowData} />
          ) : modValues.cardName === "description" ? (
            <div className="discussionModalMessage">
              <p
                className="message"
                dangerouslySetInnerHTML={{
                  __html:
                    modValues.rowData?.description || "No Content Available",
                }}
              ></p>
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="common-table-container hideMobile mt15">
        <CommonTable
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={hygineFrequencyTasksLoading}
        />
      </div>

      <div className="lead-logs-card-container only-mobile">
        <FrequenecyTasksMobile
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          selectedTab={selectedTab}
          setModValues={setModValues}
          isAdmin={isAdmin}
        />
      </div>
    </>
  );
};

export default FrequenecyTasks;
